export class FeatureToggle {
  static isZeroQuarterEnabled() {
    return false;
  }
}
